import { render, staticRenderFns } from "./bulletin_list.vue?vue&type=template&id=d7caed76&scoped=true"
import script from "./bulletin_list.vue?vue&type=script&lang=js"
export * from "./bulletin_list.vue?vue&type=script&lang=js"
import style0 from "./bulletin_list.vue?vue&type=style&index=0&id=d7caed76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7caed76",
  null
  
)

export default component.exports